// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".fitSwatchContainer__2t-n0{display:inline-flex;gap:5px;margin-bottom:0}.fitSwatchContainer__2t-n0>button:disabled{background-color:#e6e7fd}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/components/ProductFitSwatches.module.scss"],"names":[],"mappings":"AAEA,2BACE,mBAAoB,CACpB,OAAQ,CACR,eAAgB,CAHlB,2CAMI,wBAAyB","file":"ProductFitSwatches.module.scss","sourcesContent":["@import '../root/styles/mixins';\n\n.fitSwatchContainer {\n  display: inline-flex;\n  gap: 5px;\n  margin-bottom: 0;\n\n  > button:disabled {\n    background-color: #e6e7fd;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"fitSwatchContainer": "fitSwatchContainer__2t-n0"
};
module.exports = exports;
